import { createBrowserRouter, RouterProvider } from "react-router-dom";
import routesConfig from "./config/routesConfig";

const App = () => {
  const router = createBrowserRouter(routesConfig);

  return <RouterProvider router={router} />;
};

export default App;
